import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "rounded relative border p-4 pb-16 mb-6" }

import { inject, onMounted, reactive, watch } from 'vue'
import { 
    IonSelect,
    IonSelectOption,
} from '@ionic/vue'
import BlockHeader from '@/components/layout/BlockHeader.vue'
import { Branch } from '@/interfaces/types/BranchInterfaces';
import { User } from '@/interfaces/types/UserInterfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'IntroducerContactsBlock',
  emits: [
        'changeMade',
    ],
  setup(__props, { emit: __emit }) {

const pageData = inject('data') as any;

const emit = __emit
const displayData = reactive({
    introducerBranches: [] as Branch[],
    introducerUsers: [] as User[],
});

function filterBranches() {
    displayData.introducerBranches = pageData.introducer_branches.filter((branch: Branch) => {
        return branch.company_id === pageData.data.introducer_company_id;
    });
}

function filterUsers() {
    displayData.introducerUsers = pageData.introducer_users.filter((user: User) => {
        return user.branches.includes(pageData.data.introducer_branch_id)
            || ( user.company_id === pageData.data.introducer_company_id && user.type === 'introducer-admin');
    });
}
watch(() => [pageData.data.introducer_company_id,
            pageData.data.introducer_branch_id,
            pageData.data.introducer_id], () => {
            emit('changeMade');
});

onMounted(() => {
    if(pageData.data.introducer_company_id) {
        filterBranches();
        filterUsers();
    }
});


return (_ctx: any,_cache: any) => {
  const _component_input_wrapper = _resolveComponent("input-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BlockHeader, { heading: "Introducer" }),
    _createVNode(_component_input_wrapper, { label: "Company" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelect), {
          placeholder: "Select Company",
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (filterBranches())),
          value: _unref(pageData).data.introducer_company_id,
          modelValue: _unref(pageData).data.introducer_company_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pageData).data.introducer_company_id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelectOption), { value: "" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("None", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).introducer_companies, (company, index) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: index,
                value: company.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(company.name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_input_wrapper, {
      label: "Branch",
      error: _unref(pageData).errors.introducer_branch_id
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelect), {
          disabled: !_unref(pageData).data.introducer_company_id,
          placeholder: "Select Branch",
          onIonChange: _cache[2] || (_cache[2] = ($event: any) => (filterUsers())),
          value: _unref(pageData).data.introducer_branch_id,
          modelValue: _unref(pageData).data.introducer_branch_id,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pageData).data.introducer_branch_id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelectOption), { value: "" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("None", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayData.introducerBranches, (branch, index) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: index,
                value: branch.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(branch.name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled", "value", "modelValue"])
      ]),
      _: 1
    }, 8, ["error"]),
    _createVNode(_component_input_wrapper, {
      label: "Assigned User",
      error: _unref(pageData).errors.introducer_id
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonSelect), {
          disabled: !_unref(pageData).data.introducer_branch_id,
          placeholder: "Select User",
          onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('changeMade'))),
          value: _unref(pageData).data.introducer_id,
          modelValue: _unref(pageData).data.introducer_id,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pageData).data.introducer_id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelectOption), { value: "" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("None", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayData.introducerUsers, (user, index) => {
              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                key: index,
                value: user.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.full_name + (user.type === 'introducer-admin'? ' - Admin': '')), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled", "value", "modelValue"])
      ]),
      _: 1
    }, 8, ["error"])
  ]))
}
}

})